<template>
  <div>
    <div class="box-header title-boreder">
      <h3 class="box-title title">Avance de pedidos</h3>
    </div>
    <div class="box box-success">
      <div class="box-header title-boreder">
        <h3 class="box-title box-title-sub">
          <img class="icon-space" src='/static/img/icons/search.png' style="padding-bottom:7px">Buscar Resultados
        </h3>
        <div class="box-tools pull-right">
          <button v-on:click="advancedSearch()" class="btn btn-link btn-lg"><i class="fa fa-filter"></i>&nbsp;&nbsp;Avanzado</button>
        </div>
      </div>
      <div class="box-body">
        <div class="filterContainer">
          <div class="row">
            <div class="col-md-2">
              <div id="divAccountSelect" style="padding-bottom:10px">
                <label>Cuenta</label>  
                <multiselect
                  :value="this.selectedAccount"
                  selectLabel=""
                  selectedLabel=""
                  deselectLabel=""
                  track-by="name"
                  :placeholder="this.selectedAccount.name"
                  :allow-empty="false"
                  label="name"
                  :options="this.optionsAccount"
                  @input="onAccountSelect">
                  <span slot="noResult">
                    No se encontraron resultados
                  </span>
                </multiselect>
              </div>
            </div>
            <div class="col-md-3">
              <label for="dtDateRange">Desde - Hasta</label>
                <div class="form-group">
                  <div class="input-group">
                    <div class="input-group-addon">
                      <i class="icon-calendar"></i>
                    </div>
                    <input id="dtDateRange" mode="text" class="form-control" style="text-align: center">
                  </div>
                  <div v-show="submitted && message !== ''" class="invalid-feedback">{{ this.message }}</div>
                </div>
            </div>            
            <div class="col-md-2">
              <transition name="slide-fade">
                <div class="form-group" v-if="showAdvance">
                  <label>Tipo Pedido</label>
                  <select id="ddlTypeOrder" v-model="typeOrder" class="form-control minimal">
                    <option v-for="type in this.optionTypeOrder" v-bind:key="type.code" v-bind:value="type.code">
                      {{ type.text }}
                    </option>
                  </select>
                </div>
              </transition>
            </div>
            <div class="col-md-2">
              <transition name="slide-fade">
                <div class="form-group" v-if="showAdvance">
                  <label>Estado</label>
                  <select id="ddlDocumentStatus" v-model="documentStatus" class="form-control minimal">
                    <option v-for="type in this.optionDocumentStatus" v-bind:key="type.code" v-bind:value="type.code">
                      {{ type.text }}
                    </option>
                  </select>
                </div>
              </transition>
            </div>
            <div class="col-md-3">
              <div class="form-group" style="padding-top:25px;">
                <button class="btn btn-success btnAction" @click="search()">Buscar</button>
              </div>
            </div>
          </div>
          <div class="row">
            <transition name="slide-fade">
            <div class="col-md-5" v-if="showAdvance">
              <div id="divClientSelect" style="padding-bottom:10px">
                <label>Cliente</label>  
                <multiselect
                  :value="this.selectedClient"
                  selectLabel=""
                  selectedLabel=""
                  deselectLabel=""
                  track-by="code"
                  :placeholder="this.selectedClient.text"
                  :allow-empty="false"
                  label="text"
                  :options="this.optionsClient"
                  @input="onClientSelect">
                  <span slot="noResult">
                    No se encontraron resultados
                  </span>
                </multiselect>
              </div>
            </div>
            </transition>
          </div>
        </div>
      </div>
    </div>

    <div class="box box-success">  
          <!-- información de los pedidos -->
        <div class="box-header" v-if="(this.tableAllData && this.tableAllData.length) || (this.tableClientData && this.tableClientData.length)">
          <h3 class="box-title box-title-sub"  >
            <img src="/static/img/icons/result.png" class="icon-space" style="padding-bottom:3px;">
            PERíODO {{searchParams.StartDate | formatDate('L')}} A {{searchParams.EndDate | formatDate('L')}} 
          </h3>
        </div>
        <div class="box-body">
          <div id="ordersClientTable">
            <Vuetable 
              id="ordersClientTable"
              :api-mode="false" 
              :fields="tableClientFields"
              :data="tableClientData"
              :css="tableCSS.table"
              noDataTemplate="No se encontraron resultados">
                <!-- Fecha -->
                <template slot="shippingDate" slot-scope="props">
                  <div id="Fecha">
                      <span >{{props.rowData.shippingDate | formatDate("DD/MM/YYYY")}}</span>
                  </div>
                </template>
                <!-- Atendidos -->
                <template slot="orderCompleted" slot-scope="props">
                  <div id="Atendido">
                    <div class="progressContainer">    
                      <div class="porcentajeTotal" :style="'font-size: 14px ;margin:-3px 25px 0 -85px;color:#4E6982;'">{{props.rowData.totalShippedPorcentage | currency}}%
                      </div>
                      <div class="progressBar" style="position: absolute !important;margin-left: -35px;margin-top: 1px;">
                        <div class="progress table-bar percentageA" :style="'background-color:#D9DEFB'">
                          <div :class="'progress-bar progress-bar '" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                                :style="'background-color:#536DFE;width:' + props.rowData.totalShippedPorcentage + '%'">
                          </div>
                        </div>
                        <div class="totalPorcentaje" :style="'margin:-16px 0px 0px 135px;color:#506A83'">
                          <span style="font-size: 14px;font-weight: bold; color:#4E6982">{{props.rowData.orderCompleted | formatAmount}}</span> 
                          <span style="font-size: 12px; color:#4e6982;font-weight: bold; color:#4E6982">{{props.rowData.minimumStockUnit}}</span> 
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- Proceso -->
                <template slot="orderProgress" slot-scope="props">
                  <div id="Proceso">
                    <div class="progressContainer">
                      <div class="porcentajeTotal" :style="'font-size: 14px ;margin: -3px 25px 0 -70px; color:#4E6982'">{{props.rowData.totalProgressPorcentage | currency}}%
                      </div>
                      <div class="progressBar" style="position: absolute !important;margin-left: -20px;margin-top: 1px;">
                        <div class="progress table-bar percentageA" :style="'background-color:#B6F5BB'">
                          <div :class="'progress-bar progress-bar'" role="progressbar"
                            aria-valuemin="0" aria-valuemax="100" :style="'background-color:#63CB68;width:' + props.rowData.totalProgressPorcentage + '%'">
                          </div>
                        </div>
                        <div class="totalPorcentaje"  :style="'margin:-16px 0px 0px 135px;color:#4E6982'">
                          <span style="font-size: 14px;font-weight: bold; color:#4E6982">{{props.rowData.orderProgress | formatAmount}}</span> 
                          <span style="font-size: 12px; color:#4e6982;font-weight: bold; color:#4E6982">{{props.rowData.minimumStockUnit}}</span> 
                        </div>
                      </div>                     
                    </div>
                  </div>
                </template>
                <!-- Pendiente -->
                <template slot="orderPending" slot-scope="props">
                  <div id="Pendientes">
                    <div class="progressContainer">
                      <div class="porcentajeTotal" :style="'font-size: 14px ;margin:-3px 25px 0 -40px; color:#4E6982'">{{props.rowData.totalPendingPorcentage | currency}}%
                      </div>
                      <div class="progressBar" style="position: absolute !important;margin-left: 12px;    margin-top: 4px;">
                        <div class="progress table-bar percentageA" :style="'background-color:#C6E9F8'">
                          <div :class="'progress-bar progress-bar'" role="progressbar"
                            aria-valuemin="0" aria-valuemax="100" :style="'background-color:#4FC3F7;width:' + props.rowData.totalPendingPorcentage + '%'">
                          </div>
                        </div>
                        <div class="totalPorcentaje"  :style="'margin:-15px  0 0 140px;color:#4E6982'">
                          <span style="font-size: 14px;font-weight: bold; color:#4E6982">{{props.rowData.orderPending | formatAmount}}</span>
                          <span style="font-size: 12px; color:#4e6982;font-weight: bold; color:#4E6982">{{props.rowData.minimumStockUnit}}</span> 
                        </div>
                      </div>                     
                    </div>
                  </div>
                </template>
                <!-- Total -->
                <template slot="orderTotal" slot-scope="props">
                  <div id="Total">
                      <span style="font-size: 16px;font-weight: bold; position:relative">{{props.rowData.orderTotal | formatAmount}}</span>
                      <span style="font-size: 14px; color:#4e6982;font-weight: bold; color:#4E6982">{{props.rowData.minimumStockUnit}}</span> 
                  </div>
                </template>
                <!-- Btn Detalle -->
                <template  slot="orderBtnDetail" scope="props">
                  <div>
                    <div class="text-center botonVerDetalle" style="margin-top:-5px">
                      <router-link  v-if="window.width > 1200"
                        :to="{name: 'OrdersProgressDetail', params: {filterOrdereDate: props.rowData, showAdvanceMain: showAdvance} }" 
                        tag="button" 
                        class="btn table-btn">
                        <span class="table-btn-icon"></span>
                      </router-link>
                        <router-link v-if="window.width < 1200" 
                          :to="{name: 'OrdersProgressDetail', params: {filterOrdereDate: props.rowData, showAdvanceMain: showAdvance} }" 
                        tag="button" 
                        class="btn table-btn verDetalle">
                        <span style=" color:#364A5D; font-size:14px;font-weight: bold;">Ver detalles</span>
                        </router-link>
                    </div>
                  </div>
                </template>
            </Vuetable>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import moment from 'moment/moment.js'
import 'bootstrap-daterangepicker/daterangepicker.css'
import 'bootstrap-daterangepicker/daterangepicker.js'
// import BarGroupChart from 'charts/BarGroupChart.js'
import StackedBarChart from 'charts/StackedBarChart.js'
import Vuetable from 'vuetable-2'
import constants from 'assets/js/constants.js'

export default {
  name: 'PerishableProducts',
  components: {
    Multiselect,
    Vuetable,
    // 'chart-progress': BarGroupChart
    'chart-progress': StackedBarChart
  },
  data () {
    return {
      showAdvance: false,
      loader: null,
      lastSearch: false,
      submitted: false,
      message: '',
      searchParams: null,
      fetchData: null,
      selectedAccount: null,
      optionsAccount: null,
      dtDocStartDate: null,
      dtDocEndDate: null,
      selectedClient: null,
      optionsClient: [{code: '', text: 'Todos'}],
      optionDocumentStatus: [],
      documentStatus: null,
      optionTypeOrder: [],
      typeOrder: null,
      chartData: null,
      tableAllData: null,
      tableClientData: null,
      window: {
        width: 0,
        height: 0
      },
      tableAllFields: [
        {
          name: 'accountCode',
          title: 'Código Cliente'
        },
        {
          name: 'accountCode',
          title: 'Cliente',
          callback: 'formatClient'
        },
        {
          name: 'orderTotal',
          title: 'Total Pedidos'
        },
        {
          name: 'orderCompleted',
          title: 'Atendido'
        },
        {
          name: 'orderProgress',
          title: 'Proceso'
        },
        {
          name: 'orderPending',
          title: 'Pendientes'
        }
      ],
      tableClientFields: [
        {
          name: '__slot:shippingDate',
          title: 'Fecha',
          callback: 'formatDate'
        },
        {
          name: '__slot:orderCompleted',
          title: 'Atendidos'
        },
        {
          name: '__slot:orderProgress',
          title: 'Proceso'
        },
        {
          name: '__slot:orderPending',
          title: 'Pendientes'
        },
        {
          name: '__slot:orderTotal',
          title: 'Total'
        },
        {
          name: '__slot:orderBtnDetail',
          title: '',
          titleClass: 'table-text'
        }
      ],
      tableCSS: {
        table: {
          tableClass: 'table table-striped table-bordered table-hovered table-content-color'
        }
      },
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      },
      headerText: ''
    }
  },
  computed: {
    ...mapGetters([
      'userClients',
      'orderProgressSeach'
    ])
  },
  created () {
    // Client
    this.optionsAccount = Array.from(this.userClients)
    this.mode = constants.ordersProgressFilterModes.pending
    this.showAdvance = this.$route.params.showAdvance
    /* if (this.userClients.length > 1) {
      this.optionsAccount.unshift(constants.defaultSelectItem)
    } */

    this.selectedAccount = this.optionsAccount[0]
    this.selectedClient = this.optionsClient[0]
    this.getTypes()
    this.getStatus()
  },
  mounted: function () {
    var self = this
    $(this.$el).find('#dtDateRange').daterangepicker({
      showDropdowns: true,
      startDate: moment().format('DD/MM/YYYY'),
      endDate: moment().format('DD/MM/YYYY'),
      dateLimit: {'days': 6},
      locale: constants.datePickerLocale
    }, function (start, end, label) {
      $('#divModeButtons button.btn-success').click()
    })
    $('#dtDateRange').on('apply.daterangepicker', function (ev, picker) {
      self.getClients()
    })

    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    if (this.$route.params.lastSearch) {
      this.selectedAccount = this.orderProgressSeach.params.Account
      $('#dtDateRange').data('daterangepicker').setStartDate(moment(this.orderProgressSeach.params.StartDate).format('DD/MM/YYYY'))
      $('#dtDateRange').data('daterangepicker').setEndDate(moment(this.orderProgressSeach.params.EndDate).format('DD/MM/YYYY'))
      this.selectedClient = this.orderProgressSeach.params.SupplierCustomer
      this.typeOrder = this.orderProgressSeach.params.CodeOrderType
      this.documentStatus = this.orderProgressSeach.params.DocumentStatusCode
    }
    this.getClients()
    this.loadLastSearch()
  },
  methods: {
    ...mapActions([
      'fetchOrdersProgressData',
      'getDocumentStatus',
      'getSupplierCustomer',
      'getItemsForAccountConfiguration'
    ]),
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
    getClass (mode) {
      let classVal = 'btn btn-sm btn-'
      classVal += this.mode === mode ? 'success' : 'default'
      return classVal
    },
    toggleClasses () {
      $('#pendingFilter').removeClass()
      $('#attendedFilter').removeClass()
      if (this.mode === constants.ordersProgressFilterModes.pending) {
        $('#pendingFilter').addClass('btn btn-sm btn-success')
        $('#attendedFilter').addClass('btn btn-sm btn-default')
      } else {
        $('#pendingFilter').addClass('btn btn-sm btn-default')
        $('#attendedFilter').addClass('btn btn-sm btn-success')
      }
    },
    formatProgress (documentProgress) {
      let classVal = ''

      if (documentProgress > 0) {
        classVal = 'success'
      }

      return classVal
    },
    onModeSelect (mode) {
      document.activeElement.blur()
      this.changeFilter(mode)
    },
    changeFilter (mode) {
      this.mode = mode
      this.toggleClasses()
      this.loadChartData()
    },
    search () {
      document.activeElement.blur()
      this.submitted = true

      if (this.validate()) {
        this.chartData = null
        this.headerText = ''
        this.tableAllData = null
        this.tableClientData = null

        this.searchParams = {
          Account: this.selectedAccount,
          AccountCode: this.selectedAccount.code,
          StartDate: $(this.$el).find('#dtDateRange').data('daterangepicker').startDate.format('YYYYMMDD'),
          EndDate: $(this.$el).find('#dtDateRange').data('daterangepicker').endDate.format('YYYYMMDD'),
          SupplierCustomer: this.selectedClient,
          SupplierCustomerCode: this.selectedClient.code,
          CodeOrderType: this.typeOrder,
          DocumentStatusCode: this.documentStatus
        }
        console.log(this.searchParams)
        this.loader = this.$loading.show({
          loader: 'dots'
        })
        this.fetchOrdersProgressData(this.searchParams).then((data) => {
          if (data != null) {
            this.fetchData = data

            this.loadClientDetail()

            this.submitted = false

            this.onLoaded()
          }
        })
      }
    },
    loadLastSearch () {
      //  Nota VM: Este metodo solo funciona si se activa la busqueda automatica cuando regrese de la pagina detalle
      if (!this.$route.params.lastSearch) {
        return
      }
      this.searchParams = {
        Account: this.orderProgressSeach.params.Account,
        AccountCode: this.orderProgressSeach.params.AccountCode,
        StartDate: this.orderProgressSeach.params.StartDate,
        EndDate: this.orderProgressSeach.params.EndDate,
        SupplierCustomer: this.orderProgressSeach.params.SupplierCustomer,
        SupplierCustomerCode: this.orderProgressSeach.params.SupplierCustomerCode,
        DocumentStatusCode: this.orderProgressSeach.params.DocumentStatusCode,
        CodeOrderType: this.orderProgressSeach.params.CodeOrderType
      }
      let filterAccountCode = this.orderProgressSeach.params.AccountCode
      this.tableClientData = []
      this.orderProgressSeach.search.orders.forEach(element => {
        if (element.accountCode === filterAccountCode) {
          this.tableClientData.push({
            shippingDate: element.date,
            orderTotal: element.totalOrders,
            orderCompleted: element.ordersCompleted,
            orderProgress: element.progressOrders,
            orderPending: element.pendingOrders,
            minimumStockUnit: element.minimumStockUnit,
            totalPendingPorcentage: element.pendingPercentage === 0 ? 0 : (100 * element.pendingOrders) / element.totalOrders,
            totalProgressPorcentage: element.progressPercentage === 0 ? 0 : (100 * element.progressOrders) / element.totalOrders,
            totalShippedPorcentage: element.completedPercentage === 0 ? 0 : (100 * element.ordersCompleted) / element.totalOrders,
            detail: element.detail
          })
        }
      })
      this.onLoaded()
    },
    validate () {
      let startDate = moment($(this.$el).find('#dtDateRange').data('daterangepicker').startDate)
      let endDate = moment($(this.$el).find('#dtDateRange').data('daterangepicker').endDate)
      let days = moment.duration(endDate.diff(startDate)).asDays()
      if (days < 0 || days > 7) {
        this.message = 'El rango de Fechas permitido es de 7 días.'
        return false
      } else {
        this.message = ''
        return true
      }
    },
    loadChartData () {
      let formattedData = this.formatChartData()

      if (this.mode === constants.ordersProgressFilterModes.pending) {
        this.chartData = {
          labels: this.formatChartLabels(),
          datasets: [
            {
              label: 'Pendientes',
              backgroundColor: formattedData.Color,
              data: formattedData.PendingPorcentage
            },
            {
              label: 'Total',
              backgroundColor: formattedData.TotalColor,
              data: formattedData.TotalPendingPorcentage
            }
          ]
        }
      } else {
        this.chartData = {
          labels: this.formatChartLabels(),
          datasets: [
            {
              label: 'Atendidos',
              backgroundColor: formattedData.Color,
              data: formattedData.ShippedPorcentage
            },
            {
              label: 'Total',
              backgroundColor: formattedData.TotalColor,
              data: formattedData.TotalShippedPorcentage
            }
          ]
        }
      }
    },
    formatChartLabels () {
      let chartLabels = []
      // moment.locale('es')
      let startDate = moment($(this.$el).find('#dtDocStartDate').data('daterangepicker').startDate)
      let endDate = moment($(this.$el).find('#dtDocEndDate').data('daterangepicker').endDate)

      let days = moment.duration(endDate.diff(startDate)).asDays()

      while (days >= 0) {
        // labels.push(this.$options.filters.formatFirstLetter(startDate.format('dddd')) + ' ' + startDate.format('DD/MM/YYYY'))
        chartLabels.push(startDate.format('DD/MM/YYYY'))
        startDate = startDate.add(1, 'days')
        days = moment.duration(endDate.diff(startDate)).asDays()
      }

      return chartLabels
    },
    formatChartData () {
      let data = this.fetchData.orders
      // Final Chart Data Object
      let chartData = {
        Total: [],
        Shipped: [],
        Color: [],
        TotalColor: [],
        Pending: [],
        TotalPendingPorcentage: [],
        TotalShippedPorcentage: [],
        PendingPorcentage: [],
        ShippedPorcentage: []
      }

      // Data sorting by Date
      if (data) {
        data.sort(function (a, b) {
          return new Date(a.date) - new Date(b.date)
        })
      }

      // Chart Labels
      let labels = this.formatChartLabels()

      let formatObj = {}

      labels.forEach(element => {
        formatObj[element] = {
          Total: 0,
          Pending: 0
        }
      })

      // Format Data against Chart Labels
      data.forEach(element => {
        let currentDate = moment(element.date).format('DD/MM/YYYY')
        if (formatObj[currentDate] !== undefined) {
          formatObj[currentDate].Total += element.totalOrders
          formatObj[currentDate].Pending += element.pendingOrders
          formatObj[currentDate].Color = element.chartColor && element.chartColor != null ? element.chartColor : constants.colorPalette.baseBlue
          formatObj[currentDate].TotalColor = element.chartColor && element.chartColor != null ? element.chartColor + '80' : constants.colorPalette.baseBlue
        }
      })

      // Formatted Data against Final Chart Data Object
      labels.forEach(element => {
        let formattedItem = formatObj[element]
        chartData.Total.push(formattedItem.Total)
        chartData.Shipped.push(formattedItem.Total - formattedItem.Pending)
        chartData.Pending.push(formattedItem.Pending)
        chartData.Color.push(formattedItem.Color)
        chartData.TotalColor.push(formattedItem.TotalColor)
        chartData.TotalPendingPorcentage.push(Math.round((100 - ((formattedItem.Pending * 100) / formattedItem.Total)), 2))
        chartData.TotalShippedPorcentage.push(Math.round((100 - (((formattedItem.Total - formattedItem.Pending) * 100) / formattedItem.Total)), 2))
        chartData.PendingPorcentage.push(Math.round(((formattedItem.Pending * 100) / formattedItem.Total), 2))
        chartData.ShippedPorcentage.push(Math.round((((formattedItem.Total - formattedItem.Pending) * 100) / formattedItem.Total), 2))
      })

      return chartData
    },
    /* Table Events */
    onLoading () {
      this.loader = this.$loading.show({
        loader: 'dots'
      })
    },
    onLoaded () {
      if (this.loader !== null) {
        this.loader.hide()
      }
    },
    formatClient (value) {
      let formattedVal = this.userClients.filter(item => item.code === value)
      return formattedVal.length > 0 ? formattedVal[0].name : ''
    },
    formatDate (value) {
      return value ? moment(value).format('DD/MM/YYYY') : ''
    },
    /* DropDownList Events */
    getClients () {
      if (this.showAdvance) {
        this.onLoading()
        this.optionsClient = [{code: '', text: 'Todos'}]
        let params = {
          accountCode: this.selectedAccount.code,
          documentType: 'PE',
          startDate: $(this.$el).find('#dtDateRange').data('daterangepicker').startDate.format('YYYYMMDD'),
          endDate: $(this.$el).find('#dtDateRange').data('daterangepicker').endDate.format('YYYYMMDD')
        }
        this.getSupplierCustomer(params).then((response) => {
          this.optionsClient = [
            {code: '', text: 'Todos'},
            ...response]
          this.onLoaded()
          // this.resetTableClientData()
        })
      }
    },
    getTypes () {
      this.optionTypeOrder = []
      let params = {
        accountCode: this.selectedAccount.code,
        typeConfigurationId: 3
      }
      this.getItemsForAccountConfiguration(params).then((response) => {
        this.optionTypeOrder = [
          {code: null, text: 'Todos'},
          ...response]
      })
    },
    getStatus () {
      this.optionDocumentStatus = []
      this.getDocumentStatus().then((response) => {
        this.optionDocumentStatus = [
          {code: null, text: 'Todos'},
          ...response]
      })
    },
    resetTableClientData () {
      if (!this.$route.params.lastSearch) {
        this.tableAllData = []
        this.tableClientData = []
      }
      this.$route.params.lastSearch = false
      this.onLoaded()
    },
    onAccountSelect (account) {
      this.selectedAccount = account
      this.selectedClient = this.optionsClient[0]
      this.getClients()
      this.typeOrder = null
      this.getTypes()
      this.documentStatus = null
      this.getStatus()
      $('#dtDateRange').data('daterangepicker').setStartDate(moment().format('DD/MM/YYYY'))
      $('#dtDateRange').data('daterangepicker').setEndDate(moment().format('DD/MM/YYYY'))
      this.resetTableClientData()
    },
    onClientSelect (client) {
      this.selectedClient = client
    },
    // VM: Comentado para optimizar la Pantalla
    /* Chart Events */
    /* loadDetail (selectedDate, mode) {
      if (this.searchParams.AccountCodes.length === 1) {
        return
      }

      if (selectedDate) {
        this.headerText = selectedDate
      } else {
        this.headerText = moment(this.searchParams.StartDate).format('DD/MM/YYYY') + ' - ' + moment(this.searchParams.EndDate).format('DD/MM/YYYY')
      }

      let formatObj = {}
      this.fetchData.forEach(element => {
        if (selectedDate === undefined || selectedDate === moment(element.date).format('DD/MM/YYYY')) {
          if (formatObj[element.accountCode]) {
            formatObj[element.accountCode].Total += element.totalOrders
            formatObj[element.accountCode].Pending += element.pendingOrders
          } else {
            formatObj[element.accountCode] = {
              Total: element.totalOrders,
              Pending: element.pendingOrders
            }
          }
        }
      })

      this.tableAllData = []
      let keys = Object.keys(formatObj)

      keys.forEach(element => {
        let formattedItem = formatObj[element]
        this.tableAllData.push({
          accountCode: element,
          orderTotal: formattedItem.Total,
          orderCompleted: formattedItem.Total - formattedItem.Pending,
          orderPending: formattedItem.Pending
        })
      })
    }, */
    loadClientDetail () {
      let filterAccountCode = this.searchParams.AccountCode
      this.tableClientData = []
      this.fetchData.orders.forEach(element => {
        if (element.accountCode === filterAccountCode) {
          this.tableClientData.push({
            shippingDate: element.date,
            orderTotal: element.totalOrders,
            orderCompleted: element.ordersCompleted,
            orderProgress: element.progressOrders,
            orderPending: element.pendingOrders,
            minimumStockUnit: element.minimumStockUnit,
            totalPendingPorcentage: element.pendingPercentage === 0 ? 0 : (100 * element.pendingOrders) / element.totalOrders,
            totalProgressPorcentage: element.progressPercentage === 0 ? 0 : (100 * element.progressOrders) / element.totalOrders,
            totalShippedPorcentage: element.completedPercentage === 0 ? 0 : (100 * element.ordersCompleted) / element.totalOrders,
            detail: element.detail
          })
        }
      })
    },
    advancedSearch () {
      this.optionsClient = [{code: '', text: 'Todos'}]
      this.selectedClient = this.optionsClient[0]

      this.typeOrder = null
      this.documentStatus = null

      if (this.showAdvance) {
        this.showAdvance = false
      } else {
        this.showAdvance = true
        this.getClients()
      }
    }
  },
  destroyed () {
    this.onLoaded()
  }
}
</script>

<style>
.vuetable-th-slot-shippingDate {
  width: 15%; 
}

.vuetable-th-slot-orderCompleted{ 
  width: 20%; 
}

.vuetable-th-slot-orderProgress{ 
  width: 20%; 
}

.vuetable-th-slot-orderPending{ 
  width: 20%; 
}

.vuetable-th-slot-orderTotal{ 
  width: 10%; 
}

.vuetable-th-slot-orderBtnDetail{ 
  width: 5%; 
}

.verDetalle{
  margin-bottom: 0px !important;
}

#tablaAvance{
  margin-right: 0 !important;
  margin-left: 0 !important;
}

#divAccountSelect, #divSearchSelect{ 
  height: 34px;
}

#divAccountSelect.multiselect__tags, #divSearchSelect .multiselect__tags{ 
  border-radius: 0px !important;
  min-height: 34px;
  height: 34px;
}

#divAccountSelect .multiselect__select{ 
  border-radius: 0px !important;
  height: 34px;
}

#pendingFilter{
  height: 30px !important;
}

#attendedFilter{
  height: 30px !important;
}
 
#ordersClientTable td {
  padding: 10px 10px 10px 10px !important;
} 

.table-content-color{
  color: #4E6982;
}

.divClientSelectMulti{
  width: 18% !important;
}

@media screen and (max-width: 1330px) {
  .divClientSelectMulti{
    width: 20% !important;
  }
}

@media screen and (max-width: 1150px) {
  .divClientSelectMulti{
    width: 40% !important;
    padding-bottom: 10px;
  }
}

@media screen and (max-width: 990px) {
  .divClientSelectMulti{
    width: 100% !important;
  }
}

@media screen and (max-width: 1200px) {
  #ordersClientTable .progressContainer {
    position: absolute !important;
    width: 50%;
  }
  #ordersClientTable .progressBar {
    margin-top: -4px !important;
  }

  .totalPorcentaje{
    display: none;
  }

  .barraProgress{
    float: right;
    margin-right: 100px;
  }

  .barraProgress2{
    float: right;
    margin-right: 90px;
  }

  #FECHA{
    padding: 0!important;
    text-align: right;
    margin-bottom: -20px;
  }
  
  #ordersClientTable #Atendido .progressContainer{
    left: 82% !important;
    position: absolute !important;
  }

  .porcentajeTotal{
    font-size: 14px !important;
  }
  
  #ordersClientTable #Pendientes .progressContainer{
    left: 82% !important;
    position: absolute !important;
  }
 
  #ordersClientTable #Total{
    margin-bottom: -10px;
    padding-right: 10px;
    text-align: right;
  }

  .porcentajeTotal{
    float: left;
  }

  .totalPorcentaje{
    margin:-25px  10 0 110px !important;
  }
  
  #ordersClientTable table {
    border: 0;
  }

  #ordersClientTable table thead {
    display: none;
  }

   /*  #ordersClientTable td {
    padding: 23px !important;
    } */

  #ordersClientTable table tr {
    margin-top: 10px;
    margin-bottom: 20px;
    display: block;
    border:  3px solid;
    border-color:#F2F4F6;
    background-color: white !important;
  }

  #ordersClientTable table td {
    display: block;
    border: none !important;
    font-size: 13px;
    margin-bottom: 10px;
  }

  #ordersClientTable table td:last-child {
    border-bottom: 0;
  }

  #ordersClientTable table td div::before{
    content: attr(id);
    float: left;
    text-transform: uppercase;
    font-weight: bold;
  }

  #ordersClientTable	tbody{
    line-height:0!important;
  }

  .table-btn {
    float: none !important;
    background: none !important;
  }
}

@media screen and (max-width:1000px) {
  #ordersClientTable #Atendido .progressContainer{
    left: 79% !important;
    position: absolute !important;
  }

  #ordersClientTable #Pendientes .progressContainer{
    left: 79% !important;
    position: absolute !important;
  }
}

@media screen and (max-width:950px) {
  #ordersClientTable #Atendido .progressContainer{
    left: 78% !important;
    position: absolute !important;
  }
  
  #ordersClientTable #Pendientes .progressContainer{
    left: 78% !important;
    position: absolute !important;
  }
}

@media screen and (max-width:850px) {
  #ordersClientTable #Atendido .progressContainer{
    left: 75% !important;
    position: absolute !important;
  }

   #ordersClientTable #Pendientes .progressContainer{
    left: 75% !important;
    position: absolute !important;
  }
}

@media screen and (max-width:750px) {
  #ordersClientTable #Atendido .progressContainer{
    left: 70% !important;
    position: absolute !important;
  }

   #ordersClientTable #Pendientes .progressContainer{
    left: 70% !important;
    position: absolute !important;
  }
}

@media screen and (max-width:991px) {
  .datePadding-desde {
    padding-top:10px
  }
  
  .datePadding-hasta {
    padding-top:7px
    }
}

@media screen and (max-width:650px) {
  #ordersClientTable .progressBar{
    display: none;
  }

  #ordersClientTable #Atendido .progressContainer{
    left: 94% !important;
    position: absolute !important;
  }
  
  #ordersClientTable  #Pendientes .progressContainer{
   left: 94% !important;
    position: absolute !important;
  }
}

.input-group-addon{
  border-right: none;
  width: 14%;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// OrdersProgress.vue?04596193